import img1 from "./herink-1.jpg";
import img2 from "./herink-2.jpg";
import img3 from "./herink-3.jpg";
import img4 from "./herink-4.jpg";
import img5 from "./herink-5.jpg";
import img6 from "./herink-6.jpg";
import img7 from "./herink-7.jpg";
import img8 from "./herink-8.jpg";
import img9 from "./herink-9.jpg";
import img10 from "./herink-10.jpg";
import img11 from "./herink-11.jpg";
import img12 from "./herink-12.jpg";
import img13 from "./herink-13.jpg";
import img14 from "./herink-14.jpg";
import img15 from "./herink-15.jpg";
import img16 from "./herink-16.jpg";
import img17 from "./herink-17.jpg";
import img18 from "./herink-18.jpg";
import img19 from "./herink-19.jpg";
import img20 from "./herink-20.jpg";
import img21 from "./herink-21.jpg";
import img22 from "./herink-22.jpg";
import img23 from "./herink-23.jpg";
import img24 from "./herink-24.jpg";
import img25 from "./herink-25.jpg";
import img26 from "./herink-26.jpg";
import img27 from "./herink-27.jpg";
import img28 from "./herink-28.jpg";
import img29 from "./herink-29.jpg";
import img30 from "./herink-30.jpg";
import img31 from "./herink-31.jpg";
import img32 from "./herink-32.jpg";
import img33 from "./herink-33.jpg";
import fp3d from "./floorplan-3d.jpg";
import fp2d from "./floorplan-2d.jpg";

export const herinkImages = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,
  img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
  img21, img22, img23, img24, img25, img26, img27, img28, img29, img30,
  img31, img32, img33,
];

export const herinkFloorPlans = [
  { image: fp3d, label: "3D půdorys" },
  { image: fp2d, label: "2D půdorys" },
];
